import { ref, readonly } from 'vue';

/**
 * Composable to manage highlighting of linked operators when hovering over a filter.
 * When a user hovers over a filter that has linked operators (e.g., OpenEmail, ClickLink),
 * this composable tracks which operator IDs should be highlighted in the flow.
 */

const highlightedStepIds = ref<Set<string>>(new Set());

export function useLinkedOperatorHighlight() {
  /**
   * Set the step IDs that should be highlighted
   */
  const setHighlightedSteps = (stepIds: string[]) => {
    highlightedStepIds.value = new Set(stepIds);
  };

  /**
   * Clear all highlighted steps
   */
  const clearHighlightedSteps = () => {
    highlightedStepIds.value = new Set();
  };

  /**
   * Check if a step is currently highlighted
   */
  const isStepHighlighted = (stepId: string): boolean => {
    return highlightedStepIds.value.has(stepId);
  };

  return {
    highlightedStepIds: readonly(highlightedStepIds),
    setHighlightedSteps,
    clearHighlightedSteps,
    isStepHighlighted,
  };
}
